import * as React from 'react';
import { RichText, RichTextBlock } from 'prismic-reactjs';

import {
  Grid,
  Link,
  Panel,
  PanelContent,
  PanelHeader,
  Paper,
  Typography,
  WithStyles,
  withStyles,
} from '@nelnet/unifi-components-react';

import styles from './styles';

interface IContentSummaryProps extends WithStyles<typeof styles> {
  content_title?: RichTextBlock[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  content_fields?: Array<any>;
  parent_slug?: string;
}

const ContentSummary: React.FunctionComponent<IContentSummaryProps> = ({
  classes,
  content_title,
  content_fields,
  parent_slug,
}) => {
  if (!content_title) {
    return (
      <Paper>
        <Grid
          container
          spacing={2}
          constrained="80%"
          margin={{ x: 'auto' }}
          padding={{ top: 4, bottom: 4 }}
        >
          {content_fields.map((item, i) => {
            const fields = item.fields;
            const category = item.primary.category;
            const category_summary = item.primary.category_summary;
            const list_group_header = item.primary.list_group_header;
            const icon_url = item.primary.list_header_image.url;
            const icon_alt = item.primary.list_header_image.alt;
            return (
              <Grid item xs={12} sm={6} md={4} key={i}>
                {category != null ? (
                  <Typography variant="h2" className={classes.hideShowDisplay}>
                    {category}
                  </Typography>
                ) : (
                  <Typography variant="h2" className={classes.hideShowDisplay} aria-hidden="true">
                    {category}
                  </Typography>
                )}
                <Typography variant="body1" className={classes.hideShowDisplay}>
                  {category_summary}
                </Typography>
                <Link underline="none">
                  <img src={icon_url} alt={icon_alt} className={classes.image} />
                </Link>
                <Typography variant="h3" className="regular">
                  {RichText.asText(list_group_header)}
                </Typography>
                {fields.map((fields_item, i) => {
                  const expand_item = fields_item.expand_list_item[0].text;
                  const expanded_item = fields_item.expanded_text;
                  return (
                    //TODO: Come back to this once UDS-573 is completed (switch SVG placement)
                    <Grid item key={i}>
                      <Panel enableCollapse>
                        <PanelHeader title={expand_item} />
                        {expanded_item.map((list_item, i) => {
                          const expanded_list_url = list_item.spans[0].data.uid;
                          const expanded_list_url_alt = list_item.spans[0].data.url;
                          return (
                            <PanelContent key={i}>
                              {expanded_list_url ? (
                                <Link
                                  underline="always"
                                  href={`/${parent_slug}/${expanded_list_url}/`}
                                  onClick={() => window.scrollTo(0, 0)}
                                >
                                  {list_item.text}
                                </Link>
                              ) : (
                                // Catch for external links
                                <Link
                                  underline="always"
                                  target="_blank"
                                  href={`${expanded_list_url_alt}`}
                                  onClick={() => window.scrollTo(0, 0)}
                                >
                                  {list_item.text}
                                </Link>
                              )}
                            </PanelContent>
                          );
                        })}
                      </Panel>
                    </Grid>
                  );
                })}
              </Grid>
            );
          })}
        </Grid>
      </Paper>
    );
  } else {
    return (
      <Paper>
        <Grid container justify="center" padding={{ top: 6 }}>
          <Grid item xs={12}>
            <Typography variant="h2">{RichText.asText(content_title)}</Typography>
          </Grid>
        </Grid>
        <Grid container padding={{ top: 2, bottom: 6 }}>
          {content_fields.map((content_item, i) => {
            const icon_url = content_item.node.image.url;
            const icon_alt = content_item.node.image.alt;
            const item_title = content_item.node.title;
            const item_summary = content_item.node.header_content;
            const content_slug = content_item.node._meta.uid;
            return (
              <Grid item xs={12} sm={6} md={4} key={i} className={classes.contentWithImage}>
                <Link underline="none">
                  <img src={icon_url} alt={icon_alt} className={classes.image} />
                </Link>
                <Typography variant="h3" className="regular">
                  {RichText.asText(item_title)}
                </Typography>
                <Typography variant="body1" margin={{ bottom: 1 }}>
                  {RichText.asText(item_summary)}
                </Typography>
                <Link
                  underline="always"
                  href={`/${parent_slug}/${content_slug}`}
                  onClick={() => window.scrollTo(0, 0)}
                >
                  {`${item_title[0].text} Components`}
                </Link>
              </Grid>
            );
          })}
        </Grid>
      </Paper>
    );
  }
};
export default withStyles(styles)(ContentSummary);
